import React from "react";
import nextId from "react-id-generator";
import { Switch } from "react-router";
import { MainContext } from "../Dashboard/DashboardContext/Context";
import RegisterBody from "./RegisterBody/RegisterBody";
import RegisterSidebar from "./RegisterSidebar/RegisterSidebar";
import "./registration.style.scss";
export default function Registration() {
  const context = React.useContext(MainContext);
  const { userDetails, registrationStep } = context;
  const [mobileSidebar, setMobileSidebar] = React.useState(false);
  const [selectedStep, setSelectedStep] = React.useState(steps[0]);

  return !userDetails ? (
    "Loading...."
  ) : (
    <div className="registration-main">
      <aside
        className={`registration-sidebar-wrapper ${
          mobileSidebar ? "open-mobile-sidebar" : ""
        }`}
      >
        <button
          onClick={() => setMobileSidebar(!mobileSidebar)}
          className="register-sidebar-toggle"
        >
          <img src="https://img.icons8.com/ios/50/ffffff/more-than.png" />
        </button>
        <RegisterSidebar
          selectedStep={selectedStep}
          setSelectedStep={setSelectedStep}
          steps={registrationStep}
        />
      </aside>
      <div className="registration-body-wrapper">
        <RegisterBody
          tempData={registrationStep}
          selectedStep={selectedStep}
          setSelectedStep={setSelectedStep}
        />
      </div>
    </div>
  );
}

const steps = [
  {
    keyId: nextId(),
    number: 1,
    title: "Personal Details",
    id: "personal",
  },
  {
    keyId: nextId(),
    number: 2,
    title: "Qualification",
    id: "qualification",
  },
  {
    keyId: nextId(),
    number: 3,
    title: "Employment",
    id: "employment",
  },
  {
    keyId: nextId(),
    number: 4,
    title: "Your Preferences",
    id: "preferences",
  },
  {
    keyId: nextId(),
    number: 5,
    title: "Your CV / Resume",
    id: "resume",
  },
];
